import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import Box from '../../../../Global/Box'
import CategoryFilter from './CategoryFilter'
import ActivityTimeline from './ActivitiTimeLine'
import {
  GET_LAST_ONES_TIMELINES,
} from '../../../../../graphql/Catalog/Timeline/timelines'
import { GET_ACTIVITY_REPORTS_COUNTERS } from '../../../../../graphql/Document/DashboardActivityByRol/dashboardActivityByRol'
import { GET_ALL_GROUPS_CATEGORIES_AND_SUBS_BY_CONTEXT } from '../../../../../graphql/Catalog/Groups/groupsCategories'
import KpiGraphics from './KpiGraphics'
import { GET_ALL_STATUS } from '../../../../../graphql/Catalog/Status/status'
import { GET_REQUIRE_ATTENTION_REPORTS } from '../../../../../graphql/Catalog/Reports/reports'
import ActivitiAttentionReports from './ActivitiAttentionReports'

const DashboardGestorGlobalIndependiente = () => {
  //STATES
  const [timeline, setTimeline] = useState({
    require_attention: [],
    latest: [],
  })
  const [counter, setCounter] = useState(null)
  const [filters, setFilters] = useState({
    array_group_category_id: null,
    array_group_category_sub_id: null,
  })
  const [category, setCategory] = useState(null)
  const [statusIds, setStatusIds] = useState([])
  const [categoriesSubs, setCategoriesSubs] = useState([])

  //QUERIES
  const {
    data: dataCounters,
    loading: loadingCounters,
    error: errorCounters,
  } = useQuery(GET_ACTIVITY_REPORTS_COUNTERS, {
    variables: { filters },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataTimeline,
    loading: loadingTimeline,
    error: errorTimeline,
  } = useQuery(GET_LAST_ONES_TIMELINES, {
    variables: { category: ['reports'], limit: 10 },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataRequireAttentionReports,
    loading: loadingRequireAttentionReports,
    error: errorRequireAttentionReports,
  } = useQuery(GET_REQUIRE_ATTENTION_REPORTS, {
    variables: { limit: 10 },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataCategories,
    loading: loadingCategories,
    error: errorCategories,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_AND_SUBS_BY_CONTEXT, {
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataStatus,
    loading: loadingStatus,
    error: errorStatus,
  } = useQuery(GET_ALL_STATUS, {
    variables: {
      type: 'Reports',
      getOwnStatus: true,
    },
  })

  //FUNCTIONS
  const handleError = (message) => toastSweetAlert({ mode: 'error', message })

  const handleChangeCategoriesSubs = (selected) => {
    if (selected?.length === 0) {
      return setFilters({ array_group_category_sub_id: null })
    }
    setFilters({
      array_group_category_sub_id: selected.map((item) => item.value),
    })
  }

  //EFECTS
  useEffect(() => {
    if (!loadingTimeline && !loadingRequireAttentionReports) {
      if (errorTimeline || errorRequireAttentionReports)
        return handleError(
          errorTimeline
            ? errorTimeline.message
            : errorRequireAttentionReports.message
        )
      setTimeline({
        require_attention: dataRequireAttentionReports.getRequireAttentionReports,
        latest: dataTimeline.getLastOnesTimelines,
      })
    }
  }, [
    dataTimeline,
    loadingTimeline,
    errorTimeline,
    dataRequireAttentionReports,
    loadingRequireAttentionReports,
    errorRequireAttentionReports,
  ])

  useEffect(() => {
    if (!loadingCounters) {
      if (errorCounters) return handleError(errorCounters.message)
      setCounter(dataCounters?.getActivityReportsCountersByRol)
    }
  }, [dataCounters, loadingCounters, errorCounters, filters])

  useEffect(() => {
    if (!loadingCategories) {
      if (errorCategories) return handleError(errorCategories.message)
      if (dataCategories?.categories.length === 0) {
        setCategory(null)
        setCategoriesSubs([])
        return
      }

      const mainCategory = dataCategories?.categories[0]

      setCategory({
        id: mainCategory?.id,
        name: mainCategory?.name,
        description: mainCategory?.description,
      })

      if (mainCategory?.subs.length === 0) {
        return setCategoriesSubs([])
      }

      const listCategoriesSub = mainCategory?.subs.map((sub) => ({
        value: sub.id,
        label: sub.name,
      }))
      setCategoriesSubs(listCategoriesSub)
    }
  }, [dataCategories, loadingCategories, errorCategories])

  useEffect(() => {
    if (!loadingStatus) {
      if (errorStatus) return handleError(errorStatus.message)
      let listStatus = []
      dataStatus?.getAllCatalogStatus?.rows
        .filter((status) => status.id !== 7 && status.id !== 15)
        ?.map((status) => {
          listStatus.push(status.id)
        })
      setStatusIds(listStatus)
    }
  }, [dataStatus, loadingStatus, errorStatus])

  return (
    <>
      {/* <Box
        title=""
        classNameHeader=""
        contentHeader=""
        clasCard="card pb-0"
        content={
          <>
            <div className="mb-2">
              <b>Categoria:</b> {category?.name ?? ''}
            </div>
            {counter && <KpiCardsMini data={counter.category} />}
          </>
        }
      /> */}

      <Box
        title="Indicadores"
        classNameHeader="mt-3"
        contentHeader=""
        content={
          <>
            <CategoryFilter
              options={categoriesSubs}
              onChange={handleChangeCategoriesSubs}
              titleContent={
                <label>
                  Subcategorias{` `}
                  <small>
                    (Puedes filtrar, selecciona una o varias opciones)
                  </small>
                </label>
              }
            />
            {counter && (
              <KpiGraphics
                data={
                  filters?.array_group_category_sub_id
                    ? counter.subcategory
                    : counter.category
                }
              />
            )}
          </>
        }
      />

      <ActivitiAttentionReports
        reports={timeline?.require_attention}
        loading={loadingRequireAttentionReports}
        statusIds={statusIds}
      />
      <ActivityTimeline timeline={timeline?.latest} loading={loadingTimeline} />
    </>
  )
}

export default DashboardGestorGlobalIndependiente
